import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';



import {SpinnerProvider} from "./context/SpinnerContext";
import {Spinner} from "./components/Spinner";




const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <React.Fragment  >
        <SpinnerProvider>
            <App/>
            <Spinner/>
        </SpinnerProvider>
    </React.Fragment>
);



